import type { RouteObject } from "react-router"

export const clientsRoutes: RouteObject[] = [
  {
    path: "clients",
    lazy: () => import("./clients-page").then((m) => ({ Component: m.ClientsPage })),
  },
]
